<template>
    <div class="comment-wrapper">
        <div class="comment-top">
            <span class="rate-row">
                <span class="comment" v-cloak>
                    <span>
                        <span class="c-num" v-text="others.score || 0"></span>
                    </span>
                </span>
                <span class="rate">
                    <div class="score-wra">
                        <star-white :score="others.score"></star-white>
                    </div>
                </span>
            </span>
            <span class="rate-row-right">
                <span class="comment" v-cloak>
                    <span class="c-num" v-text="others.recordCount || 0"></span>条评论
                </span>
            </span>
        </div>
        <div class="comment-center">
            <van-pull-refresh v-model="isLoading" @refresh="pullDownRefresh">
                <img slot="loading" :src="loadingSrc" class="boms-loading-sm">
                <img slot="normal" :src="loadingSrc" class="boms-loading-sm">
                <img slot="pulling" :src="loadingSrc" class="boms-loading-sm">
                <img slot="loosing" :src="loadingSrc" class="boms-loading-sm">
                <van-list v-model="pullUpLoading" :finished="isMaxData" @load="pullUpLoadData">
                    <div
                        class="each-comment"
                        :class="{'active':computedContent(item.id)}"
                        v-for="(item, index) in tmpData"
                        :key="index"
                    >
                        <div class="each-comment-left" v-text="item.score || 0"></div>
                        <div
                            class="each-comment-right"
                            :class="{'active':computedContent(item.id)}"
                        >
                            <div class="flex-wra">
                                <img :src="item.profile || defaultUser.avatar" alt="avatar-image" class="avatar"/>
                                <div class="mid-lane">
                                    <div class="user-name text-overflow" v-text="item.userName || defaultUser.name"></div>
                                </div>
                                <div class="date" v-text="dealCommentTime(item.commentTime)"></div>
                            </div>
                            <div
                                id="comment-text"
                                class="content multiple-text-overflow3"
                                :class="{'active':computedContent(item.id)}"
                                @click.self.stop="changeText(item)"
                            >
                                {{item.content}}
                                <!-- <div class="r"  @click.self.stop="changeText(item)"
                                v-show="!computedContent(item.id)">das<span ></span></div>-->
                            </div>
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>
        </div>
    </div>
</template>

<script>
import StarWhite from "@/components/common/StarWhite.vue";
export default {
    name: "GoodsComment",
    components: { StarWhite },
    data() {
        return {
            defaultUser: {
                avatar: API.ossUrl + "common/empty_icons/noimage-1-1.png?param=1",
                name: "未知用户"
            },
            slideDown: false,
            isLoading: false,
            isShow: false,
            pullUpLoading: false,
            isMaxData: false,
            currentPage: 0,
            numberInEachPage: 10,
            currentSelect: [],
            tmpData: [],
            others: {},
            loadingSrc: ""
        };
    },
    computed: {
        
    },
    watch: {},
    created() {},
    mounted() {
        this.loadingSrc = API.ossUrl + "yyq/loading.gif";
    },
    destroyed() {},
    methods: {
        dealCommentTime(time){
           return time.substring(0,11) ;
        },
        changeText(item) {
            let index = this.currentSelect.findIndex(e => e.id == item.id);
            this.currentSelect.push(item);
        },
        computedContent(id) {
            if (this.currentSelect.find(e => e.id === id)) {
                return (this.slideDown = true);
            }
        },
        getCommentDataFromPage(number = 1) {
            let vm = this;
            let body = {
                pageNo: number,
                pageSize: this.numberInEachPage,
                type: 2,
                product_id: this.$route.query.id,
                specs_id: this.$route.query.specsId
            };
            return this.$axios.post(window.API.getComment, body);
        },
        //下拉刷新
        pullDownRefresh() {
            let vm = this;
            this.getCommentDataFromPage(1)
                .then(({ data }) => {
                    if (data.code == 200) {
                        let res = data.data;
                        vm.tmpData = res.list;
                        vm.others = res;
                        vm.isLoading = false;
                        vm.currentPage = 1;
                        vm.isMaxData = res.pageNo >= res.pageCount;
                    } else {
                        vm.$toast(data.msg);
                    }
                })
                .catch(err => console.log(err));
        },
        //上拉加载
        pullUpLoadData(number) {
            let vm = this;
            this.getCommentDataFromPage(vm.currentPage + 1)
                .then(({ data }) => {
                    if (data.code == 200) {
                        let res = data.data;
                        vm.tmpData = vm.tmpData.concat(res.list);
                        vm.others = res;
                        vm.pullUpLoading = false;
                        vm.currentPage = Number(res.pageNo);
                        vm.isMaxData = res.pageNo >= res.pageCount;
                    } else {
                        vm.$toast(data.msg);
                    }
                })
                .catch(err => console.log(err));
        }
    }
};
</script>
<style scoped lang="scss">
.comment-wrapper {
    height: 100%;
    padding: 0.533333rem 0 0 0.533333rem;
    .comment-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 8.933333rem;
        height: 1.306667rem;
        background: linear-gradient(
            90deg,
            rgba(255, 209, 2, 1) 0%,
            rgba(247, 151, 29, 1) 100%
        );
        border-radius: 0.16rem;
        // margin-bottom: 0.213333rem;
        padding: 0.186667rem 0.266667rem 0.16rem 0.266667rem;
        // background: $white;
        .rate-row {
            display: flex;
            align-items: center;
            .rate {
                padding-left: 0.2rem;
                span {
                    color: $white;
                    font-size: 0.4rem;
                    font-weight: bold;
                }
            }
            .comment {
                padding-right: 0.2rem;
                span {
                    font-size: 0.373333rem;
                    color: #333;
                }
                .num {
                    color: $orange;
                }
                .c-num {
                    font-size: 0.693333rem;
                    font-weight: 600;
                    color: $white;
                    line-height: 0.986667rem;
                }
            }
        }
        .rate-row-right {
            span {
                font-size: 0.373333rem;
                font-weight: 500;
                color: $white;
                line-height: 0.533333rem;
            }
        }
    }
    .comment-center {
        width: 100%;
        height: 100%;
        background: $white;
        .each-comment {
            display: flex;
            padding-top: 0.333333rem;
            padding-bottom: 0.453333rem;
            // min-height: 3.2rem;
            height: 100%;
            &.active {
                height: 100%;
            }
            .each-comment-left {
                width: 0.906667rem;
                height: 0.533333rem;
                text-align: center;
                margin-right: 0.266667rem;
                margin-top: 0.266667rem;
                line-height: 0.533333rem;
                background: linear-gradient(
                    90deg,
                    rgba(255, 209, 2, 1) 0%,
                    rgba(247, 151, 29, 1) 100%
                );
                border-radius: 0.373333rem;
                text-align: center;
                color: $white;
                font-weight: 600;
            }
            .each-comment-right {
                width: 7.7rem;
                // min-height: 4.453333rem;
                &.active {
                    height: 100%;
                }
                .flex-wra {
                    // margin-bottom: 0.466667rem;
                    display: flex;
                    flex-wrap: nowrap;
                    align-items: center;
                    justify-content: space-between;
                    .avatar {
                        width: 1.066667rem;
                        height: 1.066667rem;
                        border-radius: 50%;
                        margin-right: 0.266667rem;
                    }
                    .mid-lane {
                        flex: 1 0 auto;
                        max-width: 5.8rem;
                        .user-name {
                            color: $grey5;
                            font-size: 14px;
                            font-weight: 500;
                            margin-bottom: 0.266667rem;
                        }
                        .score-wra {
                            display: flex;
                            align-items: center;
                            .score {
                                color: $orange;
                                font-size: 14px;
                                margin-left: 0.133333rem;
                            }
                        }
                    }
                    .date {
                        font-size: 12px;
                        color: #8c8c8c;
                        align-self: flex-start;
                    }
                    &.active {
                        height: 100%;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        // -webkit-line-clamp: 3;
                        overflow: hidden;
                    }
                }
                .content {
                    position: relative;
                    margin-top: 0.266667rem;
                    font-size: 14px;
                    color: #666666;
                    background: $white;
                    word-break: break-all;
                    max-height: 1.6rem;
                    line-height: 0.533333rem;
                    // padding-right: 0.24rem;
                    &.active {
                        max-height: 100%;
                        display: block;
                        padding-right: 0rem;
                    }
                }
                .r {
                    position: absolute;
                    top: 1.1rem;
                    right: -3px;
                    font-size: 14px;
                    font-weight: 600;
                    color: #f8b356;
                    line-height: 0.533333rem;
                }
            }
        }
    }
}
</style>

